module.exports = __webpack_public_path__ + "down_small_active.png?de21475110dbc31736309f887d27c7de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down_small_active.png
// module id = 961
// module chunks = 2